import React from 'react';
import { Icon } from 'modules';

interface SearchResultProps {
  loading?: boolean;
  data?: GQL.ICreditor[];
  onClick: (creditor: GQL.ICreditor) => void;
}

const SearchResult = ({ loading, data, onClick }: SearchResultProps) => {
  return (
    <div className="creditorSelect__results">
      {loading && (
        <div className="loading">
          <Icon type="spinner" />
        </div>
      )}
      {data && (
        <div className="data">
          <ul>
            {data?.map((creditor: GQL.ICreditor) => {
              return (
                <li key={creditor.id} onClick={() => onClick(creditor)}>
                  {creditor.jmeno}
                </li>
              );
            })}
            {data.length === 0 && <li className="disable-focus">Žiadny veriteľ nenájdený</li>}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SearchResult;
